import React, { useEffect } from "react";

import { useRouter } from "next/router";

import { Link } from "@chakra-ui/next-js";
import { VStack, Image, Text } from "@chakra-ui/react";

import bugFixing from "@/assets/images/fixing_bugs.svg";

export default function ErrorFallback({ resetError }: { resetError: () => void }) {
  const router = useRouter();

  useEffect(() => {
    resetError();
  }, [resetError, router]);

  return (
    <VStack spacing={2}>
      <Image alt="Error Bug Fixing" src={bugFixing} />
      <Text mt={3}>
        <strong>Whoops!</strong> Looks like we ran into an error, we&apos;re sorry about that!
        <br />
        Try refreshing the page or click <Link href={"/home"}>here</Link> to return home.
      </Text>
    </VStack>
  );
}
